export default __webpack_public_path__ + "static/media/gallery_01.477f4251.jpg";